/* eslint-disable import/no-extraneous-dependencies */
import {
  createStore,
  combineReducers,
} from 'redux';

export default createStore(
  combineReducers({}),
);